import { cms_logging } from './cms_logging'
import { Dispatcher, BatchedDispatcher } from './redux/Dispatcher';
import { Actions, Action } from './redux/Actions';
import { Keys } from './redux/Datastore';
import { QueryString } from './QueryString';
import { State } from './redux/State';
import { exists } from './utils';
import { Configuration } from './Configuration';

function reload_all() {
    //    get_work_order_query();
    //    refetchAllData() // a re-fetch the data from the API to update the state and force the UI to be redrawn.
}

export function initialize(is_ios_app: boolean): void {
    if (is_ios_app) {
        var menu_attachments_container = document.getElementById('menu_attachments_container');
        if (menu_attachments_container) {
            menu_attachments_container.removeChild(document.getElementById('menu_attachments_content'));
            cms_logging.log(' hiding menu_attachments_content')
        }
    }
    let bd: BatchedDispatcher = new BatchedDispatcher();

    bd.add(Action.set_key_boolean(Keys.ENABLED_FEATURE_ASSETS, Configuration.assets_feature_enabled));

    bd.add(Action.set_key_boolean(Keys.ENABLED_FEATURE_ATTACHMENTS, Configuration.attachments_feature_enabled));
    bd.add(Action.set_key_boolean(Keys.ENABLED_FEATURE_FINDINGS, Configuration.findings_feature_enabled));
    bd.add(Action.set_key_boolean(Keys.ENABLED_FEATURE_SPOTSHADOW,  Configuration.spotshadow_feature_enabled));
    if(exists(QueryString.workorder_query)){
        bd.add(Action.set_workorder_query(QueryString.workorder_query));
    }
    bd.dispatch();

    let clear_menu_container = (id: string) => {
        const el = document.getElementById(id);
        if (el) {
            el.innerHTML = "";
        }
    }

    if (!Configuration.assets_feature_enabled) {
        clear_menu_container('menu_assets_container');
    }
    // if (!Configuration.rpt_feature_enabled) {
    //     document.getElementById('menu_fsi_private_container').innerHTML = "";
    // }

    if (!Configuration.attachments_feature_enabled) {
        clear_menu_container('menu_attachments_container');
    }
    if(!Configuration.workorders_feature_enabled){
        clear_menu_container('menu_workorders_container');
    }
    if(!Configuration.spotshadow_feature_enabled){
        clear_menu_container('menu_spotshadow_container');
    }
    if (!Configuration.findings_feature_enabled) {
        clear_menu_container('menu_findings_container');
    }

    reload_all();
}

export function toggle_create_finding_mode(state:State) {
    if (state.state_creating_finding) {
        if ($("#set_asset_mode_alert").length == 0) {
            let html:string = `
            <div class="alert  alert-info collapse" role="alert" id="set_asset_mode_alert">
              <strong>Double click on the map to add a Finding.</strong>
              <button type="button" class="close" aria-label="Cancel" id="set_asset_mode_alert_cancel">
                <span aria-hidden="true">Cancel</span>
              </button>
            </div>`
            $("#alerts_container").append(html)
            $('#set_asset_mode_alert_cancel').on('click', function () {
                Dispatcher.dispatch(Actions.SET_ADD_FINDINGS_STATE, false)
            })
        }
        $('#set_asset_mode_alert').show();
    }
    else {
        $('#set_asset_mode_alert').hide();
    }
    const map = document.getElementById("map");
    if (map) {
        map.style.cursor = state.mouse_cursor;
    }
}



// WEBPACK FOOTER //
// ./src/ts/cms_view.ts